// src/com/trans_plan_tsr/TransPlanTsrDict.js


/**
 * TRANS_PLAN_TSR React Component Dictionary for Input and Output
 * Project: NewTOP for cloud
 * 2025-01-02 14:52:35 using DbdbTap
 * https://www.dbdbtap.com
 */
export const TransPlanTsrDictionary = {
    errorTitle: {
        Save: 'TSR 저장 오류',
        Get: 'TSR 조회 오류',
    },
};
